export const mr = {
    "TRIGGER_LISTEN": "ट्रिगर्ससाठी ऐकत आहे",
    "ASSIST_EMPTY_MSG": "एजेंट एआय तुमच्या चर्चेला सक्रियपणे ऐकत आहे आणि जेव्हा ट्रिगर होतो तेव्हा स्वत संचालित सहाय्य करण्यास तयार आहे.",
    "MYBOT_TRIGGET_LISTEN": "आत्ताच एक्टिव्ह माय बॉट काम नाहीत.",
    "MYBOT_EMTPY_MSG": "माय बॉटवर एक कार्य सुरू करण्यासाठी, शोध टॅबवर जा आणि तुमच्या इच्छित कार्यासाठी \"\"एजंट इनपुटसह चालवा\"\" पर्याय निवडा",
    "PROACTIVE_MODE": "पूर्वक्रियात्मक मोड",
    "SETTINGS": "सेटिंग्ज",
    "HELP_AND_SUPPORT": "मदत आणि समर्थन",
    "HELP": "मदत",
    "LANGUAGE": "भाषा",
    "THEME": "थीम",
    "FILE_NAME":"फाइलचे नाव",
    "AUTO_SCROLL_TOOLTIP":"सहाय्यता टॅब, माझा बॉट आणि ट्रान्सक्रिप्ट टॅब सामग्रीच्या स्वयंचलित स्क्रोलिंगचे नियंत्रण करते",
    "AUTOMATIC": "स्वयंचलित",
    "DARK": "गडद",
    "LIGHT": "प्रकाश",
    "THEME_DESC": "ह्या तुमच्या प्रणालीच्या मूल्यांकनाचा वापर करेल",
    "DOCUMENTATION": "दस्तऐवजीकरण",
    "DOC_DESC": "आमच्या आळावधीच्या दस्तऐवजीकरण लेखांना तपासा.",
    "FAQ_U": "सामान्य प्रश्नांची तपासणी",
    "FAQ_DESC": "एजंट एआयविश्वात अक्षरीत्या विचारलेल्या प्रश्नांची तपासणी करा.",
    "KORE_ACADEMY": "कोरे अकॅडेमी",
    "KORE_ACA_DESC": "अकॅडेमीच्या पाठ्यक्रमांमध्ये जाऊन एजंट एआयविश्वात अधिक जाणून घ्या.",
    "SEARCH": "शोध",
    "MY_BOT": "माझ्या बॉट",
    "ASSIST": "सहाय्य",
    "TAB_TEXT":"कोणतेही टॅब सक्षम नाहीत! कृपया किमान एक टॅब सक्षम करा",
    "TRANSCRIPT": "ट्रान्सक्रिप्ट",
    "HISTORY": "इतिहास",
    "STARTOVER": "पुन्हा सुरू करा",
    "RESTART_INPUTS": "जप्त केलेल्या इनपुट्ससह पुन्हा सुरू करा",
    "ASKCUSTOMER": "ग्राहकाला विचारा",
    "TAP_SEARCH":"शोधण्यासाठी टॅप कराs",
    "TELLCUSTOMER": "ग्राहकाला सांगा",
    "WELCOME_MSG": "स्वागत संदेश",
    "SEND": "पाठवा",
    "SENT": "पाठविले",
    "AWAITING": "प्रतिसाद वाटत आहे | सुरु करण्यासाठी टायप करा",
    "OVERRIDE": "सुरु करण्यासाठी टायप करा",
    "OVERRIDE_FILE": "सुरु करण्यासाठी फाइल जोडा",
    "ACCEPT_RESPONSE": "प्रतिसाद स्वीकृत",
    "AGENT_ENTERED": "एजंट प्रवेश केला",
    "EXPECTED_FORMAT": "अपेक्षित स्वरुप",
    "INPUT_VALUES": "इनपुट मूल्ये",
    "RESTART": "पुन्हा सुरू करा",
    "START_OVER": "पुन्हा सुरू करा",
    "RESTART_CAPTURE": "जप्त केलेल्या इनपुट्ससह पुन्हा सुरू करा",
    "CANCEL": "रद्द करा",
    "INTERRUPT_DIALOG": "वाटचाली उपयुक्त चर्चाचे काम",
    "RUN": "चालवा",
    "RUN_AGENT": "एजंटच्या इनपुटसह चालवा",
    "STEP": "चरण",
    "DIALOG_TASK": "चर्चाचा काम",
    "FAQ": "सामान्य प्रश्नांची तपासणी",
    "SNIPPET": "उत्तरे",
    "ARTICLE": "वेब पृष्ठे",
    "FILE": "फायली",
    "SUGGESTED": "सूचित केलेलं",
    "ALL_DIALOG": "सर्व चर्चांचे काम",
    "DIALOG_TEXT": "चर्चा",
    "INTENT_IDENTIFIED": "ग्राहक वाक्य",
    "NOT_WHAT_LOOKING": "चुकीचं सूचन ?",
    "BOT": "बॉट",
    "CUSTOMER": "ग्राहक",
    "YOU": "तुम्ही",
    "TERMINATE_CONV": "चर्चाचे काम समाप्त करा",
    "TERMINATE_CONV_DESC": "तुम्हाला खात्री आहे की तुम्ही चर्चाचे काम समाप्त करायचं आहे? एजंट एआयवर कळवण्या लागणार नाहीत.",
    "YES_TERMINATE": "हो, समाप्त करा",
    "NO_CANCEL": "नको, रद्द करा",
    "OVERRIDE_CONTINUE": "ओव्हराइड मोडशी सुरू ठेवा",
    "SUMMARY_TEXT": "सारांश",
    "SUBMIT": "सबमिट करा",
    "INTERRUPT_OCCURED": "वाटचाली घडली",
    "IDENTIFIED_INTENT": "ओळखल्या गेलेल्या",
    "INTERRUPT_DESC": "या सुरू असलेल्या तुमच्या चर्चाचे काम समाप्त होईल.",
    "ACCEPT_RUN": "स्वीकृती द्या आणि चालवा",
    "RUN_LATER": "नंतर चालवा",
    "KNOW_MORE": "अधिक माहिती लावा",
    "MORE_TEXT": "अधिक",
    "LESS_TEXT": "कमी",
    "VIEW_MORE": "अधिक पाहा",
    "VIEW_LESS": "कमी पाहा",
    "SHOW_MORE_FAQ": "अधिक सामान्य प्रश्नांची दाखवा",
    "SHOW_LESS_FAQ": "कमी सामान्य प्रश्नांची दाखवा",
    "SHOW_MORE_ARTICLE": "अधिक वेब पृष्ठे दाखवा",
    "SHOW_LESS_ARTICLE": "कमी वेब पृष्ठे दाखवा",
    "SHOW_MORE_SNIPPET": "अधिक उत्तरे दाखवा",
    "SHOW_LESS_SNIPPET": "कमी उत्तरे दाखवा",
    "SHOW_MORE_FILES": "अधिक फायली दाखवा",
    "SHOW_LESS_FILES": "कमी फायली दाखवा",
    "VIEW_ALL_DIALOG": "सर्व चर्चांचे पाहा",
    "VIEW_FEW_DIALOG": "काही चर्चांचे पाहा",
    "HELP_FULL": "उपयुक्त?",
    "THANKYOU": "धन्यवाद!",
    "EXPAND_MORE": "विस्तार / अधिक",
    "CLOSE_TEXT": "बंद करा",
    "STARTED": "सुरू झाले",
    "ENDED": "समाप्त झाले",
    "VIEW_FULL_ARTICLE": "वेब पृष्ठ पाहा",
    "VIEW_FULL_FILE": "फायली पाहा",
    "COPIED": "नकली केली",
    "SENTI_ANALY": "भावना विश्लेषण",
    "WRONG_SUGGESTION": "चुकीच्या सूचना",
    "INCORRECT_INTENT": "चुकीचे उद्देश",
    "ACCIDENTAL_CLICK": "अकस्मात क्लिक",
    "TIME_TAKING": "वेळ घेत आहे",
    "OTHER": "इतर",
    "PLAYBOOK_EMPTY_MSG": "प्लेबुक निवडा",
    "PLAYBOOK_EMPTY_DESC": "एजंट एआयविश्वात आपल्याला सर्व उपलब्ध प्लेबुक्स डायनामिक असल्यामुळे लोड करण्यात अक्षम आहे. प्लेबुक्स एक्सेस करण्यासाठी 'प्लेबुक निवडा' क्लिक करा.",
    "STAGE": "स्थिती",
    "PROCEED_TO_CLOSE": "बंद करण्यास सुरू करा",
    "RECOMENDED_PLAYBOOK": "शिफारस केलेला प्लेबुक",
    "PRIMARY_SCRIPTS": "प्राथमिक स्क्रिप्ट्स",
    "DYNAMIC_SCRIPTS": "डायनामिक स्क्रिप्ट्स",
    "RESUME": "पुन्हा सुरू करा",
    "ENABLE_CLOSE": "स्थिती समाप्त करण्यासाठी सुरू करण्यासाठी क्लिक करा",
    "LIST_VIEW": "यादी पाहा",
    "TERMINATE": "समाप्त करा",
    "MINIMIZE": "कमी करा",
    "MAXIMIZE": "अधिक करा",
    "NO_SEARCH_RESULT": "कोणतेही शोध परिणाम सापडले नाहीत",
    "SENTIMENT_AWAITING": "भावना येथे प्रतीक्षा करत आहे",
    "POSITIVE": "सकारात्मक",
    "NEGATIVE": "नकारात्मक",
    "ASSOCIATED_WORK_NOTES": "गत समाधान टीका",
    "AGENT_JOINED_CONV": "एजंट चर्चेत सामील झाला",
    "AUTOSCROLL_ASSIST": "स्वत स्क्रॉल सहाय्य टॅब सामग्री",
    "FILE_SIZE_MSG": "फाइल आकार 25MB आत असावा. कृपया पुन्हा प्रयत्न करा.",
    "OVERRIDE_BTN": "ओव्हरराईड",
    "PLAYBOOK": "प्लेबुक",
    "CHOOSE_FILE": "फाइल निवडा",
    "SUMMARY_ERROR_TEXT": "आम्ही खेद करतो, परंतु या चर्चेसाठी सारांश उत्पन्न करण्यात समस्या आली. कृपया स्वतःच्या सारांशाची तयारी करा.",
    "ASK_A_QUESTION": "प्रश्न प्रश्निका",
    "COPY" : "प्रत",
    "TELL_US_MORE": "अधिक सांगा",
    "THANKS_FEEDBACK": "आपल्या फीडबॅकसाठी धन्यवाद",
    "SOMETHING_WRONG": "काहीतरी चुकलं आहे",
    "CLICK_ERROR_DETAILS": "त्रुटीची माहिती पाहण्यासाठी क्लिक करा",
    "NO_ACTIVE_PLAYBOOK": "कोणताही सक्रिय प्लेबुक नाही",
    "REPHRASE_QUESTION": "तुमचा प्रश्न पुन्हा विचारू शकाल का किंवा काहीतरी इतर विचारू शकाल का?",
    "INTERNAL_INFO": "आंतरिक माहिती",
    "SOURCES": "स्रोत",
    "CONVERSATION_SUMMARY": "संवादाचा सारांश",
    "WAITING": "आहेत",
    "WIDGET_DISABLED": "विजेट निष्क्रिय आहे",
    "AI_SETTINGS_DISABLED": "AI सेटिंग्ज निष्क्रिय आहेत! कृपया AI व्यवस्थापकांशी संपर्क साधा",
    "SERVER_CONNECTION_ERROR": "सर्व्हरशी कनेक्ट करताना त्रुटी",
    "VIEW": "पहा",
    "ATTACHMENT_INPUT": "जोडणी इनपुट",
    "TYPE_SUMMARY": "सारांश टाइप करा",
    "VIEW_FULL_ARTICLE_2": "पूर्ण लेख पहा",
    "VIEW_FULL_FILE_2": "पूर्ण फाईल पहा",
    "BY":"द्वारे",
    GENERATE_SUMMARY: "सारांश तयार करा",
    PREV_SUMMARIES: "पूर्वी तयार केलेले सारांश",
    DIALOG_WORKFLOWS: "डायलॉग वर्कफ्लो",
    SHOW_ALL_DIALOG: "सर्व डायलॉग कार्य दर्शवा",
    SHOW_ALL_DIALOGS: "सर्व डायलॉग दर्शवा",
    CUSTOM_TAB: "कस्टम टॅब",
    AGENT_INPUT: "एजेंट इनपुट",
    "CUSTOM_EMPTY_MSG" : "आत्ताच सक्रिय वर्कफ्लो नाही",
    "CUSTOM_TAB_DESC" : "एक वर्कफ्लो सुरू करण्यासाठी, स्क्रीनच्या तळावरील यादीमधून एक चालवा.",
    "SUBMIT_OVERALL_FEEDBACK" : "समस्त प्रतिक्रिया पाठवा",
    "FEEDBACK_POPUP_SUBTITLE" : "विजेट आणि त्याचे कार्यक्षमता बद्दल आपले अनुभव",
    "FEEDBACK_SATISFIED" : "संतुष्ट",
    "FEEDBACK_UNSATISFIED" : "संतुष्ट नाही",
    "FEEDBACK_PROVIDE_REASONS" : "अधिक माहिती द्या…",
    "FEEDBACK_TITLE" : "प्रतिक्रिया",
    "AGENTIC_THINKING" : "विचार करत आहे",
    "AGENTIC_AGENT_TITLE" : "एजंट",
    "AGENTIC_COPILOT_MODE_TITLE" : "एजंटिक कोपिलॉट मोड",
    "AGENTIC_SENDING_MESSAGE" : "पाठवत आहे...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot तुमच्या संभाषणाला सक्रियपणे ऐकत आहे आणि स्वयंचलितपणे मदत करण्यासाठी तयार आहे",
    "AGENTIC_SEARCH_RESULTS" : "एजंट परिणाम",
    "PAUSE_AUTO_SEND" : "स्वयंचलित पाठवणे थांबवा",
    "PAUSE_AGENTIC" : "एजंट थांबवा",
    "RESUME_AGENTIC" : "एजंट पुन्हा सुरू करा",
    "RESUME_AUTO_SEND" : "स्वयंचलित पाठवणे पुन्हा सुरू करा"
}